import { TeamTypeEnum } from '@monetize/types/app';
import { objectToSelectOptions } from '../utils/misc';

export const TEAM_TYPE_ENUM_DISPLAY: {
  [key in TeamTypeEnum]: string;
} = {
  SALES: 'Sales',
  APPROVAL: 'Approval',
};

/**
 * Read-only display map. The backend also returns a `LEGACY` type on old
 * teams that can no longer be created or saved, so it is deliberately absent
 * from `TEAM_TYPE_DISPLAY_OPTIONS` (used by the create/edit form).
 */
export const TEAM_TYPE_DISPLAY: Record<string, string> = {
  ...TEAM_TYPE_ENUM_DISPLAY,
  LEGACY: 'Legacy',
};

export const TEAM_TYPE_DISPLAY_OPTIONS = objectToSelectOptions(
  TEAM_TYPE_ENUM_DISPLAY,
);
